// extracted by mini-css-extract-plugin
module.exports = {"info":"info-2vl48","aircraft__nameTitle":"aircraft__nameTitle-2xqSo"};